
export const CUSTOM_METRICS = {
  B_APP_BUSINESS_STATUS_CHANGE_NUM: {
    KEY: 'B_APP_BUSINESS_STATUS_CHANGE_NUM',
    TAGS_KEY: 'type',
    TAGS: {
      OPEN: 'OPEN',
      BUSY: 'BUSY',
      CLOSE: 'CLOSE',
    },
  },
  B_APP_BUSINESS_STATUS_CHANGE_SUCCESS_NUM: {
    KEY: 'B_APP_BUSINESS_STATUS_CHANGE_SUCCESS_NUM',
    TAGS_KEY: 'type',
    TAGS: {
      OPEN: 'OPEN',
      BUSY: 'BUSY',
      CLOSE: 'CLOSE',
    },
  },
  B_APP_BUSINESS_STATUS_CRASH_NUM: {
    KEY: 'B_APP_BUSINESS_STATUS_CRASH_NUM',
  },
}

